import { FC, PropsWithChildren, useMemo } from 'react';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { ButtonBase } from '../../../../common';
import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { BorderedTextInput } from '../../reusable/FATCAInputs/BorderedTextInput/BorderedTextInput';

const InputWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: 'extra_small_2',
      textAlign: 'start',
    })}
  >
    {children}
  </div>
);

const FATCAResidencyJustifyNoTinNumberInTextScreen: FC<{
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
  translations: FATCATranslations;
}> = ({ fatcaFormState, translations }) => {
  const { t } = useClientTranslation();

  const { fatcaTaxResidencies, onNextStep } = fatcaFormState;

  const { fatcaTaxResidencies: fatcaTaxResidencyEntries } = fatcaTaxResidencies;

  const { buttonDisabled, residencyEntriesWhichRequireTextArgument } =
    useMemo(() => {
      const residencyEntriesWhichRequireTextArgument =
        fatcaTaxResidencyEntries.filter(
          (entry) =>
            'tinAbsentTextReasonRequired' in entry &&
            (entry as any).tinAbsentTextReasonRequired,
        );

      const buttonDisabled = residencyEntriesWhichRequireTextArgument.some(
        (item) =>
          !('tinAbsentTextReasonRequired' in item) || !item.tinAbsentTextReason,
      );

      return { residencyEntriesWhichRequireTextArgument, buttonDisabled };
    }, [fatcaTaxResidencyEntries]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
      })}
    >
      {residencyEntriesWhichRequireTextArgument.map((entry) => {
        return (
          <section key={entry.id}>
            <h6 className={css({ mb: 'small' })}>
              {t(
                'fatca_missing_tin_code_reason_ask' as 'missing_translation_key',
                {
                  country: entry.countryValue,
                },
              )}
            </h6>
            {'tinAbsentTextReasonRequired' in entry && (
              <InputWrapper>
                <label htmlFor={`text-reason-input-for-${entry.id}`}>
                  Reason:
                </label>
                <BorderedTextInput
                  placeholder={translations.insert_your_reason}
                  id={`text-reason-input-for-${entry.id}`}
                  value={entry.tinAbsentTextReason ?? ''}
                  onChange={(e) => {
                    fatcaFormState.fatcaTaxResidencies.updateFATCATaxResidency(
                      entry.id,
                      {
                        ...entry,
                        tinAbsentTextReason: e.target.value,
                      },
                    );
                  }}
                />
              </InputWrapper>
            )}
          </section>
        );
      })}
      <ButtonBase
        fullWidth
        size="large"
        disabled={buttonDisabled}
        onClick={() => {
          onNextStep();
        }}
      >
        {translations.iAgree}
      </ButtonBase>
    </div>
  );
};

export { FATCAResidencyJustifyNoTinNumberInTextScreen };
